var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import parse from "html-react-parser";
import { getClassName } from "../../../helpers";
import { CARD, CARD_TITLE, CARD_DESCRIPTION } from "../../../classConstants";
import { usePresentationComponent } from "../../../AppContext";
import { Flex } from "../../Flex";
import styled from "styled-components";
export var Card = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.bodyClass, bodyClass = _c === void 0 ? "" : _c, _d = _a.context, context = _d === void 0 ? "" : _d, _e = _a.name, name = _e === void 0 ? "" : _e, _f = _a.title, title = _f === void 0 ? "" : _f, _g = _a.isInline, isInline = _g === void 0 ? false : _g, _h = _a.description, description = _h === void 0 ? "" : _h, children = _a.children;
    var Component = usePresentationComponent(context ? context + ".card" : "card") || "div";
    var renderTitle = function () {
        if (!title) {
            return null;
        }
        title = typeof title === "string" ? parse(title) : title;
        return React.createElement(CardTitle, { className: CARD_TITLE }, title);
    };
    var renderDescription = function () {
        if (!description) {
            return null;
        }
        description = typeof description === "string" ? parse(description) : description;
        return React.createElement(CardDescription, { className: CARD_DESCRIPTION }, description);
    };
    return (React.createElement(Component, { className: getClassName(CARD, className) },
        renderTitle(),
        renderDescription(),
        React.createElement(CardBody, { className: bodyClass, isInline: isInline }, children)));
};
export var ReactiveCard = function (props) {
    var formOptions = useFormApi();
    return React.createElement(Card, __assign({}, props), formOptions.renderForm(props.fields, formOptions));
};
var CardBody = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    justify-content: space-between;\n"], ["\n    justify-content: space-between;\n"])));
var CardTitle = styled.h3(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: 15px;\n"], ["\n    margin-bottom: 15px;\n"])));
var CardDescription = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 15px;\n"], ["\n    margin-bottom: 15px;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
